// extracted by mini-css-extract-plugin
export default {"seeSimilarButton":"B8pq8"};